import AlternativesCarousel from './AlternativesCarousel'

export default AlternativesCarousel
